
import {
  axios,
  PercentTypeList,
  EnvironmentDataAuxList,
  RateAuxList
} from 'src/api'
import { ChannelHeritageParentList } from 'src/api/models/channelHeritageParentList.model'

export interface ApiGetChannelHeritageDataParamsData {
  userToken: string
  environmentDataId: string
}

export interface ApiGetChannelHeritageDataParams {
  serverPath: string
  data: ApiGetChannelHeritageDataParamsData
  controller?: AbortController
}

export interface ApiGetChannelHeritageDataResponse {
  type: string
  errorList: any[]
  ok: boolean
  status: string
  statusType: string
  advancedChannelHeritageOption: boolean
  channelHeritageParentList?: ChannelHeritageParentList[]
  environmentDataAuxList: EnvironmentDataAuxList[]
  rateAuxList: RateAuxList[]
  percentTypeList: PercentTypeList[]
}

export const ApiGetChannelHeritageData = async ({ serverPath, data, controller }:ApiGetChannelHeritageDataParams) => {
  const res = await axios.post<ApiGetChannelHeritageDataResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/getchannelheritagedata`,
    data,
    {
      signal: controller?.signal
    }
  )
  return res.data
}
